export type Locale = "ru" | "kk" | "en";

export type StaticDocument = {
  slug: string;
  locale: string;
  content: string;
};

export type UpdateDocumentRequest = {
  slug: string;
  locale: Locale;
  content: string;
};

// Список редактируемых документов и их человекочитаемые названия.
// slug'и должны совпадать с seed'ом на сервере (core-service).
export const DOCUMENTS: { slug: string; title: string }[] = [
  { slug: "terms_of_offer", title: "Условия оферты" },
  { slug: "transportation_rules", title: "Правила перевозки" },
  { slug: "privacy_policy", title: "Политика конфиденциальности" },
  { slug: "legal_entities", title: "Для юридических лиц" },
];

export const LOCALES: { key: Locale; title: string }[] = [
  { key: "ru", title: "Русский" },
  { key: "kk", title: "Қазақша" },
  { key: "en", title: "English" },
];
